var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd hh:mm:ss';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
}

export default {
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {


        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            if (typeof date === 'string') return date;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        },
        completeDate(time1, time2, m) {
            var diffyear = time2.getFullYear() - time1.getFullYear();
            var diffmonth = diffyear * 12 + time2.getMonth() - time1.getMonth();
            if (diffmonth < 0) { return false; } var diffDay = time2.getDate() - time1.getDate();
            if (diffmonth < m || (diffmonth == m && diffDay <= 0)) {
                if (diffmonth == m && diffDay == 0) {
                    var timeA = time1.getHours() * 3600 + 60 * time1.getMinutes() + time1.getSeconds();
                    var timeB = time2.getHours() * 3600 + 60 * time2.getMinutes() + time2.getSeconds();
                    if (timeB - timeA > 0) {
                        return false;
                    }

                } return true;
            }
            return false;
        },
        dateFromStr : function (string) {
            let nums = string.split(/[-T:\./\s]/g)
            nums[1] -= 1
            let date = new Date(...nums)
            return date
        }
    },
    guid:function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    },
    realNowTime:function(){
        let now = new Date()
        if(window.time) {
            let serverTime = Date.fromStr(window.time)
            return new Date(serverTime.valueOf() + now.valueOf() - window.basetime.valueOf())
        }
        return now
    },

};
